import * as React from 'react';

const ReadMoreSVG = (props) => (
    <svg 
        width="20" 
        height="20" 
        viewBox="0 0 20 20" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g clip-path="url(#clip0_1720_31)">
            <path 
                d="M17.0098 0.105225H3.11509C1.43088 0.105225 0.167725 1.36838 0.167725 3.05259V16.9473C0.167725 18.6315 1.43088 19.8947 3.11509 19.8947H17.0098C18.694 19.8947 19.9572 18.6315 19.9572 16.9473V3.05259C19.9572 1.36838 18.694 0.105225 17.0098 0.105225ZM18.0625 16.9473C18.0625 17.5789 17.6414 17.8947 17.1151 17.8947H3.11509C2.48351 17.8947 2.16772 17.4736 2.16772 16.9473V3.05259C2.16772 2.42101 2.48351 2.10522 3.11509 2.10522H17.0098C17.6414 2.10522 17.9572 2.52628 17.9572 3.05259L18.0625 16.9473Z" 
                fill="#5F2E05"/>
            <path 
                d="M11.1151 13.1579H9.00986C9.00986 12.8421 9.00986 12.6315 9.00986 12.6315C9.00986 12 9.11513 11.3684 9.32565 10.9473C9.53618 10.421 9.95723 9.99996 10.6941 9.36838C11.3257 8.84207 11.7467 8.42101 11.852 8.31575C12.0625 7.99996 12.1678 7.78944 12.1678 7.47365C12.1678 7.05259 11.9572 6.63154 11.6414 6.31575C11.3257 5.99996 10.7993 5.78944 10.1678 5.78944C9.53618 5.78944 9.11512 5.99996 8.69407 6.31575C8.27302 6.63154 8.06249 7.15786 7.85197 7.8947L5.7467 7.68417C5.85197 6.7368 6.27302 5.8947 7.00986 5.15786C7.7467 4.42101 8.79934 4.10522 10.0625 4.10522C11.4309 4.10522 12.4835 4.42101 13.2204 5.15786C13.9572 5.8947 14.3783 6.63154 14.3783 7.57891C14.3783 8.10522 14.273 8.52628 13.9572 9.05259C13.6414 9.47365 13.0099 10.1052 12.0625 10.9473C11.5362 11.3684 11.2204 11.6842 11.1151 11.8947C11.1151 12 11.1151 12.5263 11.1151 13.1579ZM9.00986 16.2105V13.8947H11.3257V16.2105H9.00986Z" 
                fill="#5F2E05"/>
        </g>
        <defs>
            <clipPath id="clip0_1720_31">
                <rect width={20} height={20} fill="white" transform="translate(0.0625)"/>
            </clipPath>
        </defs>
    </svg>
);
export default ReadMoreSVG;
